export default __webpack_public_path__ + "static/media/ic_notification.d7d58106.svg";